/**
 * The magazine's clickable-label style: the `Weiterlesen »` set on the Article
 * Teaser Card, shared with the author box's recent-article links so both read
 * as the same affordance (small, bold, all caps, no underline).
 */
export const MAGAZINE_LABEL_CLASS_NAME =
  'text-primary text-sm font-bold tracking-[0.05em] uppercase';
